/**
 * Basis points → percent. Rates (tax, loyalty earn, promotions) are stored as
 * integer basis points — 1900 = 19% — but operators think in percent. This is
 * the single `bps / 100` primitive; callers add their own formatting (a "%"
 * suffix, `String(...)` for an input value, or feeding an i18n template).
 */
export function bpsToPercent(bps: number): number {
  return bps / 100;
}
